//测试
//const webSite = 'http://47.111.183.226:8029/scuSelfUnitEnrollMgr' //  测
//const fileUrl = 'http://47.111.183.226:8029/scuSelfUnitEnrollMgr'
//const mobileUrl = 'http://47.111.183.226:8029'

//测试迁移
//const webSite = 'http://47.111.183.226:8036/scuSelfUnitEnrollMgr' //  测
//const fileUrl = 'http://47.111.183.226:8036/scuSelfUnitEnrollMgr'
//const mobileUrl = 'http://47.111.183.226:8036'

//临时正式
//const webSite = 'http://202.115.44.70/scuSelfUnitEnrollMgr' //  测
//const fileUrl = 'http://202.115.44.70/scuSelfUnitEnrollMgr'
//const mobileUrl = 'http://202.115.44.70/'
//const sqbmbUrl = "http://202.115.44.70/scuSelfUnitEnrollMgr/file/om/四川大学合作办学项目申请表.docx" //四川大学合作办学项目申请表  站点申请

//正式
const webSite = 'https://zk.scu.edu.cn/scuSelfUnitEnrollMgr' //  测
const fileUrl = 'https://zk.scu.edu.cn/scuSelfUnitEnrollMgr'
const mobileUrl = 'https://zk.scu.edu.cn/'
const sqbmbUrl = "https://zk.scu.edu.cn/scuSelfUnitEnrollMgr/file/om/四川大学合作办学项目申请表.docx" //四川大学合作办学项目申请表  站点申请
export default {
  webSite,
  mobileUrl,
  fileUrl,
  sqbmbUrl
}
